export default __webpack_public_path__ + "static/media/addUpload-file.d0eb5563.svg";